const translation = {
    PageSize: '页面大小',
    PageOrientation: '页面方向',
    Format: '格式',
    DPI: '像素',
    Title: '导出地图',
    Close: '关闭',
    Save: '保存',
    FileName: '文件名',
    Landscape: '横向',
    Portrait: '纵向',
    PreviewHint: '在地图上调整导出范围。',
    ExportFailed: '地图导出失败，请重试。',
    PreviewFailed: '无法生成预览。',
    AdjustArea: '在地图上调整范围',
    AdjustAreaHint: '移动、缩放、旋转或倾斜地图以框选导出范围',
    ZoomIn: '放大',
    ZoomOut: '缩小',
    ResetZoom: '重置为 100%',
    Done: '完成',
    Cancel: '取消',
    Scalebar: '比例尺',
    NorthIcon: '指北针',
    ChooseNorthIcon: '选择指北针',
    ChooseSvgFile: '选择 SVG 文件',
    IconSymbol: '符号',
    IconColor: '颜色',
    IconSize: '大小',
    InvalidSvg: '该文件不是有效的 SVG。',
    ExportAsVector: '导出为矢量',
    ExportLabelsAsVector: '将标注导出为矢量',
    Custom: '自定义',
    Width: '宽度',
    Height: '高度',
    LanguageName: '简体字',
    LanguageCode: 'zhHans'
};
export default translation;
